import { Component, ViewChild } from '@angular/core';
import { Platform, Nav } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { Keyboard } from '@ionic-native/keyboard';
import { SplashScreen } from '@ionic-native/splash-screen';

import { WelcomePage } from '../pages/welcome/welcome';
import { DashboardPage } from '../pages/employer/dashboard/dashboard';
import {TranslateService} from "@ngx-translate/core";
import { Storage } from '@ionic/storage'

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage: any = WelcomePage;
  param: string;
  @ViewChild(Nav) nav: Nav;

  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen, keyboard: Keyboard,
            private  translate: TranslateService, private storage: Storage) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();
      keyboard.disableScroll(false);
      keyboard.hideKeyboardAccessoryBar(true);
      translate.setDefaultLang('fr');

      this.storage.get('LOCAL').then(local => {
        if(local){
          this.seti18n(local)
        }else{
          this.seti18n('fr')
        }
      })
      
    });

  }

  seti18n(local){
    this.translate.use(local);
    this.storage.set('LOCAL', local).then(() => {
    })
  }


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts